import React, { useState } from 'react'
import { FaInfoCircle } from 'react-icons/fa';
import { Navigate } from 'react-router-dom'
import './info.styles.scss';

const Info = () => {
    const [goToInfo, setGoToInfo] = useState(false);

    return (
        <div className='info-container'>
            {goToInfo && <Navigate to="/info" />}
            <div className='info-text' onClick={() => { setGoToInfo(true) }}>
                <label>hai bisogno di informazioni?</label> <FaInfoCircle />
            </div>
        </div>
    )
}

export default Info